import { DESTROY_ISLOGIN, LOGIN_RESPONSE, LOGIN_RESPONSE_FALSE, PLAN_EXPIRED } from "src/Helper/actionsTypes";

export const LoginReducer = (state = [], action) => {
    switch (action.type) {
        case LOGIN_RESPONSE: {
            return { ...state, isLoggedIn: true, creds: action.payload.results, message: action.payload.message }
        }
        case 'UPDATE_CREDS': {
            return { ...state, creds:action.payload }
        }
        
        case DESTROY_ISLOGIN: {
            return { ...state, isLoggedIn: null, message: null }
        }
        case LOGIN_RESPONSE_FALSE: {
            return { ...state, isLoggedIn: false, message: action.payload.message }
        }
        case 'CLEAR_ISLOGGEDIN':{
            return { ...state, isLoggedIn: null, message: null }
        }
        case 'UPDATE_FYSD':{
            return {...state,creds:action.payload}
        }
         default: return state
    }
    // if (action.type === LOGIN_RESPONSE) return { ...state, isLoggedIn: true, creds: action.payload.results, message:action.payload.message }
    // if(action.type === 'UPDATE_CREDS') return {...state,creds:action.payload}
    // if(action.type === DESTROY_ISLOGIN) return {...state, isLoggedIn:false, message:''}
    // if(action.type === 'TOKEN_CHANGE') return {...state, isLoggedIn:false, message:''}
    // return state;
} 